import { mostrarToast } from "./toast";
import { tocarSomNovaMensagem } from "./somNovaMensagem";

/**
 * Entrega dos avisos na tela. O canal "Push" das preferências decide se o
 * usuário vê o toast; o "Som" já é respeitado dentro de `tocarSomNovaMensagem`.
 * O valor fica no localStorage para que qualquer tela consulte sem recarregar
 * as preferências do servidor.
 */
const CHAVE_PUSH_NOTIFICACOES = "i9:notificacoes-push";

export function definirPushNotificacoesAtivo(ativo: boolean) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CHAVE_PUSH_NOTIFICACOES, ativo ? "1" : "0");
}

export function pushNotificacoesAtivo(): boolean {
  return typeof window === "undefined"
    || window.localStorage.getItem(CHAVE_PUSH_NOTIFICACOES) !== "0";
}

/**
 * Aviso padrão de novidade: toca o som e, com Push ligado, sobe o toast que a
 * plataforma já usa. Chamado pelos canais de atendimento e pelo painel de
 * notificações.
 */
export function avisarNotificacao(titulo: string, detalhe = "") {
  tocarSomNovaMensagem();
  if (!pushNotificacoesAtivo()) return;
  const texto = String(titulo || "").trim() || "Você recebeu uma nova notificação.";
  const complemento = String(detalhe || "").trim();
  mostrarToast(complemento ? `${texto} — ${complemento}` : texto, "info");
}
